// leaf-town - critters: the six friends you can play as. Built from rectangles, then inked like every other sprite.
(function () {
  'use strict';
  const G = window.G, C = G.COL, K = C.ink;
  const CW = 30, CH = 27, OX = 15, OY = 23;   // sprite canvas, and where the point between the feet sits in it

  // Every critter is drawn facing right in "units" around its feet (y < 0 is up).
  // r(x0, y0, x1, y1, col) fills [x0,x1) x [y0,y1). s = pose: b (body drop), l0/l1 (leg lengths), a (arms, <0 = raised),
  // reach (forward stretch while swiping), ey (eyes up/down), sit.
  // eye(x, y, n) draws one ink eye n px tall that knows how to blink, squint and go wide.
  const CRITTERS = [
    {
      id: 'sprout', ko: '새싹', en: 'Sprout', col: '#7fd08a', hi: '#c6f2a8',
      pal: { body: '#7fd08a', hi: '#c6f2a8', lo: '#3f8a55', leaf: '#a6e88f', vein: '#2f7a52', cheek: '#ff9db5', foot: '#2f7a52' },
      feet: [-3, 1],
      draw(r, s, P, eye) {
        const b = s.b, ly = -14 + b + Math.max(-2, Math.round(Math.min(0, s.a) * 0.6)), rc = s.reach;
        r(0, ly + 2, 1, -9 + b, P.lo);                                         // stem
        r(-3, ly + 1, 0, ly + 3, P.leaf); r(-6, ly, -3, ly + 2, P.leaf); r(-7, ly - 1, -5, ly, P.leaf); r(-4, ly + 2, 0, ly + 3, P.vein); r(-6, ly + 1, -4, ly + 2, P.vein);
        r(1, ly + 1, 4 + rc, ly + 3, P.leaf); r(4 + rc, ly, 7 + rc, ly + 2, P.leaf); r(6 + rc, ly - 1, 8 + rc, ly, P.leaf); r(1, ly + 2, 5 + rc, ly + 3, P.vein); r(5 + rc, ly + 1, 7 + rc, ly + 2, P.vein);
        r(-4, -10 + b, 4, -2 + b, P.body); r(-5, -9 + b, 5, -3 + b, P.body);  // the bud
        r(-4, -10 + b, 1, -9 + b, P.hi); r(-5, -8 + b, -4, -5 + b, P.hi);
        r(-4, -3 + b, 4, -2 + b, P.lo); r(4, -8 + b, 5, -3 + b, P.lo);
        eye(1, -7 + b, 2); eye(3, -7 + b, 2);
        r(4, -5 + b, 5, -4 + b, P.cheek);
      },
    },
    {
      id: 'mushroom', ko: '버섯', en: 'Shroom', col: '#e0566a', hi: '#ff8ea0',
      pal: { cap: '#e0566a', hi: '#ff8ea0', lo: '#a8304a', dot: '#fff1e0', stem: '#f4e3c8', stemLo: '#c9b49a', foot: '#8c5e36' },
      feet: [-3, 1],
      draw(r, s, P, eye) {
        const b = s.b, c = b + (s.a < -1 ? -1 : 0), d = s.reach > 0 ? 2 : 0;
        r(-3, -7 + b, 3, -2 + b, P.stem); r(2, -7 + b, 3, -2 + b, P.stemLo); r(-3, -3 + b, 3, -2 + b, P.stemLo);
        eye(0, -6 + b, 2); eye(2, -6 + b, 2);
        r(-7 + d, -10 + c, 7 + d, -7 + c, P.cap); r(-6 + d, -12 + c, 6 + d, -10 + c, P.cap); r(-4 + d, -13 + c, 4 + d, -12 + c, P.cap);
        r(-6 + d, -7 + c, 6 + d, -6 + c, P.lo);                                // gills
        r(-5 + d, -12 + c, -2 + d, -11 + c, P.hi); r(-4 + d, -13 + c, 0 + d, -12 + c, P.hi);
        r(-5 + d, -10 + c, -3 + d, -8 + c, P.dot); r(1 + d, -12 + c, 3 + d, -10 + c, P.dot); r(4 + d, -9 + c, 6 + d, -8 + c, P.dot);
      },
    },
    {
      id: 'snail', ko: '달팽', en: 'Snail', col: '#f2d37a', hi: '#c9b0ff',
      pal: { body: '#f2d37a', hi: '#fff1b8', lo: '#b9902a', shell: '#9a7ad8', shHi: '#c9b0ff', shLo: '#5f44a0' },
      draw(r, s, P, eye) {
        const b = Math.max(-1, Math.min(1, s.b)), rc = s.reach, rip = s.l0 > s.l1 ? 2 : s.l1 > s.l0 ? -2 : 0;
        const sl = 3 + Math.min(2, Math.max(0, -s.a)), hx = rc;
        r(-9, -1, 6 + hx, 0, P.body); r(-8, -3, 6 + hx, -1, P.body); r(-8, -1, 6 + hx, 0, P.lo);  // the foot
        if (rip) r(-3 + rip, -4, 1 + rip, -3, P.body);
        r(3 + hx, -7 + b, 7 + hx, -1, P.body); r(4 + hx, -8 + b, 7 + hx, -7 + b, P.body); r(4 + hx, -8 + b, 6 + hx, -7 + b, P.hi);
        const top = -8 + b - sl;
        r(4 + hx, top, 5 + hx, -8 + b, P.body); r(6 + hx, top + 1, 7 + hx, -8 + b, P.body);   // stalks
        r(3 + hx, top - 1, 5 + hx, top + 1, P.hi); r(6 + hx, top, 8 + hx, top + 2, P.hi);
        eye(4 + hx, top - 1, 1); eye(7 + hx, top, 1);
        r(4 + hx, -4 + b, 6 + hx, -3 + b, P.lo);                            // smile
        const y = b;
        r(-7, -10 + y, 2, -3 + y, P.shell); r(-6, -11 + y, 1, -10 + y, P.shell); r(-8, -9 + y, -7, -4 + y, P.shell); r(2, -9 + y, 3, -4 + y, P.shell);
        r(-5, -9 + y, 1, -8 + y, P.shLo); r(0, -8 + y, 1, -4 + y, P.shLo); r(-5, -5 + y, 0, -4 + y, P.shLo); r(-5, -8 + y, -4, -5 + y, P.shLo);
        r(-3, -7 + y, -1, -6 + y, P.shLo); r(-3, -6 + y, -2, -5 + y, P.shLo);
        r(-6, -11 + y, -2, -10 + y, P.shHi); r(-7, -10 + y, -6, -7 + y, P.shHi);
      },
    },
    {
      id: 'owl', ko: '부엉', en: 'Owl', col: '#7f8fc9', hi: '#ffe36e',
      pal: { body: '#7f8fc9', hi: '#b3c0ee', lo: '#4f5c96', belly: '#d8d0f0', ring: '#ffe36e', beak: '#f2a24e', foot: '#f2a24e' },
      feet: [-3, 1],
      draw(r, s, P, eye) {
        const b = s.b, aF = s.aF, aB = s.aB, rc = s.reach;
        if (aB < 0) r(-9, -10 + b + aB, -5, -8 + b + aB, P.lo);                 // wings out when they flap
        if (aF < 0 || rc) r(5, -10 + b + Math.min(0, aF) + (rc ? 3 : 0), 9 + rc, -8 + b + Math.min(0, aF) + (rc ? 3 : 0), P.lo);
        r(-5, -12 + b, 5, -2 + b, P.body); r(-6, -11 + b, 6, -3 + b, P.body);
        r(-5, -14 + b, -3, -12 + b, P.body); r(-6, -15 + b, -5, -13 + b, P.body); r(3, -14 + b, 5, -12 + b, P.body); r(5, -15 + b, 6, -13 + b, P.body);
        r(-5, -12 + b, -2, -11 + b, P.hi); r(-6, -10 + b, -5, -5 + b, P.hi);
        if (aB >= 0) r(-6, -8 + b, -5, -3 + b, P.lo);
        if (aF >= 0 && !rc) r(5, -8 + b, 6, -3 + b, P.lo);
        r(-3, -6 + b, 4, -3 + b, P.belly); r(-2, -5 + b, -1, -4 + b, P.lo); r(1, -5 + b, 2, -4 + b, P.lo); r(-1, -4 + b, 0, -3 + b, P.lo); r(2, -4 + b, 3, -3 + b, P.lo);
        r(-4, -11 + b, 0, -7 + b, P.ring); r(1, -11 + b, 5, -7 + b, P.ring);
        eye(-1, -10 + b, 2); eye(3, -10 + b, 2);
        r(0, -8 + b, 1, -6 + b, P.beak);
      },
    },
    {
      id: 'hedgehog', ko: '고슴', en: 'Hedgehog', col: '#a07858', hi: '#f0c8a0',
      pal: { sp: '#7a5a48', spHi: '#b08868', spLo: '#4a3226', face: '#f0c8a0', faceLo: '#c9966a', nose: K, foot: '#4a3226' },
      feet: [-4, 1],
      draw(r, s, P, eye) {
        const b = s.b, br = s.a < 0 ? 2 : 0, rc = s.reach;
        r(-7, -8 + b, 2, -2 + b, P.sp); r(-6, -10 + b, 1, -8 + b, P.sp); r(-5, -11 + b, 0, -10 + b, P.sp);
        // the back spikes stand out when it is excited
        [[-6, -12], [-4, -12], [-2, -12], [0, -11], [-8, -10], [-9, -8], [-9, -6], [-9, -4]].forEach(([x, y], i) => {
          const up = i < 4;
          if (up) r(x, y + b, x + 1, y + b + 1, P.spHi); else r(x - br, y + b, x + 1, y + b + 1, P.sp);
        });
        r(-5, -9 + b, -4, -5 + b, P.spLo); r(-2, -10 + b, -1, -6 + b, P.spLo); r(-7, -6 + b, -6, -3 + b, P.spLo); r(-4, -5 + b, -3, -3 + b, P.spHi);
        r(-5, -11 + b, -2, -10 + b, P.spHi);
        r(1, -8 + b, 5, -2 + b, P.face); r(5, -6 + b, 7 + rc, -3 + b, P.face); r(1, -3 + b, 7 + rc, -2 + b, P.faceLo);
        r(7 + rc, -6 + b, 8 + rc, -4 + b, P.nose);
        r(1, -9 + b, 3, -8 + b, P.faceLo);
        eye(3, -7 + b, 2);
      },
    },
    {
      id: 'sheep', ko: '몽실', en: 'Fluff', col: '#f4ede0', hi: '#ffffff', eyeCol: '#fff9e8',
      pal: { wool: '#f4ede0', hi: '#ffffff', lo: '#c9bfd8', face: '#3a3346', faceHi: '#5a5568', foot: '#3a3346' },
      feet: [-4, 1],
      draw(r, s, P, eye) {
        const b = s.b, rc = s.reach, ea = s.a < 0 ? -1 : 0;
        r(-6, -10 + b, 4, -3 + b, P.wool); r(-7, -9 + b, -6, -4 + b, P.wool); r(4, -9 + b, 5, -5 + b, P.wool);
        r(-5, -11 + b, -2, -10 + b, P.wool); r(-1, -11 + b, 3, -10 + b, P.wool); r(-3, -12 + b, 1, -11 + b, P.wool);
        r(-4, -12 + b, -2, -11 + b, P.hi); r(-6, -10 + b, -5, -8 + b, P.hi); r(-2, -10 + b, 0, -9 + b, P.hi);
        r(-6, -4 + b, -4, -3 + b, P.lo); r(-3, -4 + b, 0, -3 + b, P.lo); r(1, -4 + b, 3, -3 + b, P.lo); r(4, -6 + b, 5, -5 + b, P.lo);
        r(4 + rc, -9 + b, 8 + rc, -4 + b, P.face); r(5 + rc, -10 + b, 7 + rc, -9 + b, P.face); r(5 + rc, -4 + b, 7 + rc, -3 + b, P.face);
        r(3 + rc, -11 + b, 6 + rc, -9 + b, P.wool);                        // fringe
        r(2 + rc, -8 + b + ea, 4 + rc, -7 + b + ea, P.faceHi);                // ear
        eye(6 + rc, -8 + b, 2);
        r(7 + rc, -5 + b, 8 + rc, -4 + b, P.faceHi);
      },
    },
  ];
  const BY = {};
  CRITTERS.forEach((k) => (BY[k.id] = k));
  G.CRITTERS = CRITTERS;
  G.critter = (id) => BY[id] || CRITTERS[0];
  G.hero = () => G.critter(G.save.data.hero);

  // ---------- sprite cache: one small canvas per pose ----------
  const cache = new Map();
  function sprite(k, o) {
    const legs = o.legs || [2, 2, 2, 2], sit = !!o.sit;
    const s = {
      b: sit ? 2 : o.lift || 0, l0: sit ? 0 : legs[0], l1: sit ? 0 : legs[1],
      a: Math.min(o.armL || 0, o.armR || 0), aF: o.armR || 0, aB: o.armL || 0,
      reach: o.reach || 0, ey: o.eyeY || 0, sit,
    };
    const eyes = o.noEyes ? 'none' : o.blink ? 'shut' : o.eyes || '';
    const key = k.id + s.b + ',' + s.l0 + s.l1 + ',' + s.aF + ',' + s.aB + ',' + s.reach + ',' + s.ey + eyes + (o.col || '') + sit;
    let c = cache.get(key);
    if (c) return c;
    const p = G.pix(CW, CH), g = p.g;
    const r = (x0, y0, x1, y1, col) => { if (x1 > x0 && y1 > y0) { g.fillStyle = col; g.fillRect(OX + x0, OY + y0, x1 - x0, y1 - y0); } };
    const P = o.col ? new Proxy(k.pal, { get: () => o.col }) : k.pal;
    const ec = k.eyeCol || C.eye;
    const eye = (x, y, n) => {
      y += s.ey;
      if (eyes === 'none') return;
      if (eyes === 'hurt') r(x - 1, y, x + 1, y + 1, ec);
      else if (eyes === 'shut') r(x, y + n - 1, x + 1, y + n, ec);
      else if (eyes === 'wide') r(x, y - 1, x + 1, y + n, ec);
      else r(x, y, x + 1, y + n, ec);
    };
    // legs first so the body sits over their tops; sitting critters let their feet dangle over the seat edge
    if (k.feet) {
      const [f0, f1] = k.feet, fc = o.col || k.pal.foot;
      if (sit) { r(f0 + 3, -1, f0 + 5, 2, fc); r(f1 + 3, -1, f1 + 5, 2, fc); }
      else { r(f0, -2 + s.b, f0 + 2, -2 + s.b + s.l0, fc); r(f1, -2 + s.b, f1 + 2, -2 + s.b + s.l1, fc); }
    }
    k.draw(r, s, P, eye);
    if (!o.noEyes) p.outline(K);
    cache.set(key, (c = p.c));
    return c;
  }

  // (x, y) is the point between the feet. Takes the same pose options the old hero drawer took:
  // u, sx, sy, face, legs, lift, armL, armR, reach, eyes, blink, eyeY, col, alpha, noEyes - plus kind and sit.
  G.drawCritter = (g, x, y, o) => {
    o = o || {};
    const k = G.critter(o.kind), c = sprite(k, o), u = o.u || 1, sx = (o.sx || 1) * u, sy = (o.sy || 1) * u;
    if (o.alpha !== undefined) g.globalAlpha = Math.max(0, Math.min(1, o.alpha));
    g.save();
    g.translate(Math.round(x), Math.round(y));
    g.scale((o.face || 1) < 0 ? -sx : sx, sy);
    g.drawImage(c, -OX, -OY);
    g.restore();
    if (o.alpha !== undefined) g.globalAlpha = 1;
  };
  G.drawHero = (g, x, y, o) => { o = o || {}; if (!o.kind) o.kind = G.save.data.hero; G.drawCritter(g, x, y, o); };

  // the hero's pixels in its resting pose, for effects that take it apart and knit it back together
  const pixCache = {};
  G.heroPixels = () => {
    const k = G.hero();
    if (pixCache[k.id]) return pixCache[k.id];
    const c = sprite(k, { noEyes: false }), d = c.g.getImageData(0, 0, CW, CH).data, out = [], ink = G.rgb(K), eye = G.rgb(k.eyeCol || C.eye);
    for (let y = 0; y < CH; y++) for (let x = 0; x < CW; x++) {
      const i = (y * CW + x) * 4;
      if (d[i + 3] < 128) continue;
      const rgb = [d[i], d[i + 1], d[i + 2]], hex = '#' + rgb.map((v) => v.toString(16).padStart(2, '0')).join('');
      const isInk = rgb[0] === ink[0] && rgb[1] === ink[1] && rgb[2] === ink[2];
      const isEye = rgb[0] === eye[0] && rgb[1] === eye[1] && rgb[2] === eye[2];
      if (isInk && !isEye) continue;
      out.push({ x: x - OX, y: y - OY, eye: isEye, col: hex });
    }
    return (pixCache[k.id] = out);
  };
})();
